import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";

const CourseFAQForm = ({ visible, onCancel, onSubmit, initialValues }) => {
    const formik = useFormik({
        initialValues: {
            question: initialValues?.question || "",
            answer: initialValues?.answer || "",
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            question: Yup.string().required("Question is required"),
            answer: Yup.string().required("Answer is required"),
        }),
        onSubmit: (values, { resetForm }) => {
            onSubmit(values);
            resetForm();
        },
    });

    useEffect(() => {
        if (!visible) {
            formik.resetForm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);

    return (
        <Modal
            title={initialValues ? "Edit FAQ" : "Add FAQ"}
            open={visible}
            onOk={formik.handleSubmit}
            onCancel={onCancel}
            okText="Save"
            cancelText="Cancel"
        >
            <Form layout="vertical">
                <Form.Item
                    label="Question"
                    validateStatus={formik.touched.question && formik.errors.question ? "error" : ""}
                    help={formik.touched.question && formik.errors.question}
                >
                    <Input
                        name="question"
                        value={formik.values.question}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Enter question"
                    />
                </Form.Item>
                <Form.Item
                    label="Answer"
                    validateStatus={formik.touched.answer && formik.errors.answer ? "error" : ""}
                    help={formik.touched.answer && formik.errors.answer}
                >
                    <Input.TextArea
                        name="answer"
                        value={formik.values.answer}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Enter answer"
                        rows={4}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CourseFAQForm;
